import { useState } from "react";
import { hasPendingOrder, recoverOrder } from "@/utils/orderCheckout";
import { formatApiError } from "@/utils/api";
import { toast } from "sonner";

export default function OrderRecovery({ userId, disabled }) {
  const [busy, setBusy] = useState(false);
  if (!userId || !hasPendingOrder(userId)) return null;
  const recover = async () => {
    setBusy(true);
    try {
      const order = await recoverOrder(userId);
      if (order) toast.success(`${order.siparis_no} kayıtlı. Yeni sipariş vermeden önce sepetinizi gözden geçirin.`);
    } catch (e) { toast.error(formatApiError(e)); }
    finally { setBusy(false); }
  };
  return <div className="my-3 rounded-lg border border-amber-300 bg-amber-50 p-3 text-sm text-amber-900">
    <p>Önceki gönderimin yanıtı alınamadı. Aynı gönderimi güvenle tamamlayarak sonucunu kontrol edebilirsiniz.</p>
    <button disabled={busy || disabled} onClick={recover} className="mt-2 font-semibold underline disabled:opacity-50">{busy ? "Kontrol ediliyor..." : "Önceki gönderimi tamamla / kontrol et"}</button>
  </div>;
}
